module.exports = __webpack_public_path__ + "media/images/responsive/top/flow_point-4e4ddf801d604d3326311e395494c185.svg";